import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Location } from '@angular/common';
import {Router} from "@angular/router";
import { CommonService } from '../../common/common.service';

@Component({
  selector: 'nwt-power-supply-updated-dialog',
  templateUrl: './power-supply-updated-dialog.component.html'
})
export class PowerSupplyUpdatedDialog implements OnInit {

  powerSupplyName: string = '';
  nodeId: number = 0;
  nonComcast: boolean = false;
  psSuccessMsg:any;
  genomeMsg:any;
  genomecall:any;
  psUpdatedMsg:any;
  genomecallsplit:any;
  constructor(
    public dialogRef: MatDialogRef<PowerSupplyUpdatedDialog>,
    private _location: Location,
    private router: Router,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) private data) {
    this.powerSupplyName = this.data.powerSupplyName;
    this.nodeId = this.data.nodeId;
    this.nonComcast = this.data.nonComcast;
    this.genomeMsg = this.data.genomeMsg;
    this.psSuccessMsg = this.data.psSuccessMsg;
  }

  ngOnInit() {
    if (this.genomeMsg != undefined) {
      this.genomecall = this.genomeMsg.split(',');
      let genomeStatus = this.genomecall[2].trim();
      this.genomecallsplit = genomeStatus.split(':');

      var genomeSuccessTrans = this.genomecall[2].trim();
      var genomeSuccessTransStat = genomeSuccessTrans.split(':');
      var genomeSuccessTransponder = genomeSuccessTransStat[1];

      var genomeMessageTransDetail = this.genomecall[3].trim();
      var genomeMessageTransDetailStat = genomeMessageTransDetail.split(':');
      var genomeSuccessTransponderDetail = genomeMessageTransDetailStat[1].split('~');
      var genomeSuccessTransponderDetailMsg = genomeSuccessTransponderDetail[0];


      var genomeSuccessSelfTest = this.genomecall[4].trim();
      var genomeSuccessSelfTestStat = genomeSuccessSelfTest.split(':');
      var genomeSuccessSelfTest = genomeSuccessSelfTestStat[1];

      var genomeSuccessSelfTestmsg = this.genomecall[5].trim();
      var genomeSuccessSelfTestStatMsg = genomeSuccessSelfTestmsg.split(':');
      var genomeSuccessSelfTestMsg = genomeSuccessSelfTestStatMsg[1];

      //true true
      //false false
      //true false
      //false true
      if (this.psSuccessMsg && genomeSuccessTransponder.trim() == 'true' && genomeSuccessSelfTest.trim() == 'true') {
        this.psUpdatedMsg = CommonService.GencallsetDurationtruetrue;
      } else if (this.psSuccessMsg && genomeSuccessTransponder.trim() == 'false' && genomeSuccessSelfTest.trim() == 'false') {
        this.psUpdatedMsg = CommonService.GencallsetDurationfalsefalse;
      } else if (this.psSuccessMsg && genomeSuccessTransponder.trim() == 'true' && genomeSuccessSelfTest.trim() == 'false') {
        this.psUpdatedMsg = CommonService.GencallsetDurationtruefalse;
      } else if (this.psSuccessMsg && genomeSuccessTransponder.trim() == 'false' && genomeSuccessSelfTest.trim() == 'true') {
        this.psUpdatedMsg = CommonService.GencallsetDurationfalsetrue;
      } else {
        this.psUpdatedMsg = CommonService.GenomeMsg;
      }


      // if(this.psSuccessMsg && this.genomecallsplit[1].trim() == 'true'){
      //   this.psUpdatedMsg = "Genome call Successful and PowerSupply updated successfully";
      // }else if(this.psSuccessMsg && this.genomecallsplit[1].trim() == 'false'){
      //   this.psUpdatedMsg = "Genome call not Successful and PowerSupply updated successfully";
      // }else {
      //   this.psUpdatedMsg = "Successfully updated the power supply";
      // }
    }
    else {
      this.psUpdatedMsg = "Successfully updated the power supply";
    }
  }
/*Function to open the submitted status -  Popup open */
  onclickOK() {
  this.dialogRef.close();
  this.router.navigate(['/list'], { queryParams: { nodeId: this.nodeId }})
  .then(() => {
    location.reload();
  });

  }
}
